import { request } from '@services'
import { STATUS_REQUEST } from '@utils/constant'

export const state = {
  status: null,
  loading: false,
  errors: null,
}

export const getters = {
  getStatus(state) {
    return state.status
  },
  getErrors(state) {
    return state.errors
  },
}

export const mutations = {
  SET_REGISTRATION_ADMIN_REQUESTED(state) {
    state.loading = true
  },
  SET_REGISTRATION_ADMIN_RECEIVED(state) {
    state.loading = false
    state.status = STATUS_REQUEST.SUCCESS
    state.errors = null
  },
  SET_REGISTRATION_ADMIN_FAILED(state, errors) {
    state.loading = false
    state.status = STATUS_REQUEST.FAILED
    state.errors = errors
  },
  RESET_REGISTRATION_ADMIN_FAILED(state) {
    state.loading = false
    state.status = null
    state.errors = null
  },
}

export const actions = {
  async registrationAdmin({ commit }, params) {
    commit('SET_REGISTRATION_ADMIN_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/admin/add/',
        payload: {
          ...params,
        },
      })
      commit('SET_REGISTRATION_ADMIN_RECEIVED')
      return response
    } catch (error) {
      commit('SET_REGISTRATION_ADMIN_FAILED', error)
    }
  },
  resetRegistrationAdmin({ commit }) {
    commit('RESET_REGISTRATION_ADMIN_FAILED')
  },
}
